import type { CSSProperties, FunctionComponent } from 'react';
import React from 'react';
import cx from 'classnames';

import avatarStyles from '../avatar/Avatar.less';
import boardStyles from '../board-card/BoardCard.less';
import buttonStyles from './Buttons.less';
import styles from './Detail.less';

interface BoardAndDetailContainerProps {
  width?: number;
}

export const BoardAndDetailContainer: FunctionComponent<BoardAndDetailContainerProps> = ({
  width,
  children,
  ...props
}) => {
  let style: CSSProperties | undefined;
  if (width) {
    style = { width: `${width}px` };
  }
  return (
    <div
      className={cx(
        styles.boardAndDetailContainer,
        boardStyles.detailContainer,
      )}
      {...props}
      style={style}
    >
      {children}
    </div>
  );
};

export const DetailContainer: FunctionComponent = (props) => (
  <div className={styles.detailContainer} {...props} />
);

export const Header: FunctionComponent = ({ children }) => (
  <div
    className={cx(
      styles.header,
      avatarStyles.detailHeader,
      buttonStyles.detailHeader,
    )}
  >
    {children}
  </div>
);

export const DetailActions: FunctionComponent = (props) => (
  <div className={styles.detailActions} {...props} />
);

export const CommentText: FunctionComponent = (props) => (
  <div className={styles.commentText} {...props} />
);

export const ReactionContainer: FunctionComponent = (props) => (
  <div className={styles.reactionContainer} {...props} />
);

export const DetailInfoUserName: FunctionComponent = (props) => (
  <div className={styles.primary} {...props} />
);

export const DetailInfoPrimary = DetailInfoUserName;

export const DetailInfoSecondary: FunctionComponent = (props) => (
  <div className={styles.secondary} {...props} />
);

interface DetailInfoProps {
  name?: string;
  date?: string;
  children?: React.ReactNode;
}

export const DetailInfo: FunctionComponent<DetailInfoProps> = ({
  name,
  date,
  children,
  ...props
}: DetailInfoProps) => (
  <div className={styles.detailInfo} {...props}>
    {name && <DetailInfoPrimary>{name}</DetailInfoPrimary>}
    {date && <DetailInfoSecondary>{date}</DetailInfoSecondary>}
    {children}
  </div>
);

interface DueInfoProps {
  className?: string;
  cardTitle?: string;
  dueText?: React.ReactNode;
}

export const DueInfo: FunctionComponent<DueInfoProps> = ({
  className,
  cardTitle,
  dueText,
}) => (
  <span className={cx(styles.dueInfo, className)}>
    <b>{cardTitle}</b> {dueText}
  </span>
);

export const Spacer: FunctionComponent = (props) => (
  <div className={styles.spacer} {...props} />
);
